export default fn => ({
  onClick: event => fn(event),
  onKeyDown: event => {
    if (event.which == 13 || event.keyCode == 13) {
      fn(event);
    }
  },
});
